import React, { useEffect, useState } from 'react';
import { Link } from "react-scroll";
import { animateScroll as scroll } from 'react-scroll';
import { FiSun, FiMoon, FiArrowUp } from "../assets/icons/icons";

export default function Switcher() {
    let [scrollToTops, setScrollToTops] = useState(false);
    const [isDarkMode, setIsDarkMode] = useState(
        typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
    );

    useEffect(() => {
        function scrollHandler() {
            setScrollToTops(window.scrollY >= 500);
        }

        if (typeof window !== "undefined") {
            window.addEventListener('scroll', scrollHandler);
        }
        window.scrollTo(0, 0);

        return () => {
            window.removeEventListener('scroll', scrollHandler);
        };
    }, []);

    useEffect(() => {
        if (typeof document === 'undefined') return undefined;

        const syncTheme = () => {
            setIsDarkMode(document.documentElement.classList.contains('dark'));
        };

        syncTheme();

        if (typeof MutationObserver === 'undefined') return undefined;
        const observer = new MutationObserver(syncTheme);
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

        return () => observer.disconnect();
    }, []);

    let scrollToTop = () => {
        scroll.scrollToTop({
            duration: 500,
            smooth: true,
        });
    }

    function changeMode(mode, event) {
        switch (mode) {
            case 'mode':
                if (isDarkMode) {
                    document.documentElement.classList.remove('dark');
                    document.documentElement.classList.add('light');
                    localStorage.setItem('mode', 'light');
                    setIsDarkMode(false);
                } else {
                    document.documentElement.classList.remove('light');
                    document.documentElement.classList.add('dark');
                    localStorage.setItem('mode', 'dark');
                    setIsDarkMode(true);
                }
                break;
            case 'layout':
                if (event.target?.innerText === "LTR") {
                    document.documentElement.dir = "ltr";
                } else {
                    document.documentElement.dir = "rtl";
                }
                break;
            default:
                break;
        }
    }

    return (
        <>
            <div className="fixed top-1/4 -right-3 z-50">
                <span className="relative inline-block rotate-90">
                     <input
                        type="checkbox"
                        className="checkbox opacity-0 absolute"
                        id="chk"
                        checked={isDarkMode}
                        onChange={(event) => changeMode('mode', event)}
                        aria-label="Toggle dark mode"
                    />
                    <label className="label bg-slate-100 dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 shadow-sm dark:shadow-gray-900/40 cursor-pointer rounded-full flex justify-between items-center p-1 w-14 h-8" htmlFor="chk">
                        <FiSun width={18} className="text-[18px] text-amber-500" />
                        <FiMoon width={18} className="text-[18px] text-indigo-400" />
                        <span className="ball bg-white dark:bg-white rounded-full absolute top-[2px] left-[2px] size-7 shadow-sm ring-1 ring-slate-200/70 dark:ring-white/10"></span>
                    </label>
                </span>
            </div>

            {/* Uncomment this if you need RTL/LTR switch */}
            {/* <div className="fixed top-[40%] -right-3 z-50">
                <Link to="#" id="switchRtl" className="cursor-pointer">
                    <span className="py-1 px-3 relative inline-block rounded-t-md -rotate-90 bg-white dark:bg-slate-900 shadow-md dark:shadow dark:shadow-gray-800 font-semibold rtl:block ltr:hidden" onClick={(event) => changeMode('layout', event)}>LTR</span>
                    <span className="py-1 px-3 relative inline-block rounded-t-md -rotate-90 bg-white dark:bg-slate-900 shadow-md dark:shadow dark:shadow-gray-800 font-semibold ltr:block rtl:hidden" onClick={(event) => changeMode('layout', event)}>RTL</span>
                </Link>
            </div> */}

            <Link to="#" onClick={scrollToTop}
                id="back-to-top" className={`${!scrollToTops ? "hidden" : "back-to-top fixed  text-lg rounded-full z-10 bottom-5 end-2 size-9 text-center bg-indigo-600 text-white leading-9 flex items-center justify-center"}`}><FiArrowUp width={18} /></Link>
        </>
    );
}
